export const MODALIDADES = [
  'Pregão Eletrônico',
  'Pregão Presencial',
  'Concorrência Eletrônica',
  'Concorrência Presencial',
  'Dispensa de Licitação',
  'Inexigibilidade',
];

export const CATEGORIAS = [
  'Infraestrutura',
  'Saneamento',
  'Energia',
  'Tecnologia da Informação',
  'Saúde',
  'Educação',
  'Defesa e Segurança',
  'Meio Ambiente',
  'Agricultura',
  'Mobilidade Urbana',
  'Edificações',
  'Consultoria e Assessoria',
  'Serviços Gerais',
];

export const UFS_BR = [
  'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
  'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN',
  'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO',
];

/**
 * Mapeamento região -> UFs usado como fallback quando `/licitacoes/meta`
 * está indisponível. Espelha `REGIOES_UFS` do backend
 * (server/src/utils/licitacoes-filtros.js) — chaves em snake_case sem acento.
 */
export const REGIOES_UFS_FALLBACK: Record<string, string[]> = {
  norte: ['AC', 'AM', 'AP', 'PA', 'RO', 'RR', 'TO'],
  nordeste: ['AL', 'BA', 'CE', 'MA', 'PB', 'PE', 'PI', 'RN', 'SE'],
  centro_oeste: ['DF', 'GO', 'MS', 'MT'],
  sudeste: ['ES', 'MG', 'RJ', 'SP'],
  sul: ['PR', 'RS', 'SC'],
};

/** Rótulos acentuados das regiões, na ordem de exibição. */
export const REGIOES_LABELS: Array<{ key: string; label: string }> = [
  { key: 'norte', label: 'Norte' },
  { key: 'nordeste', label: 'Nordeste' },
  { key: 'centro_oeste', label: 'Centro-Oeste' },
  { key: 'sudeste', label: 'Sudeste' },
  { key: 'sul', label: 'Sul' },
];

/** Esferas administrativas aceitas pelo filtro `esferas`. */
export const ESFERAS: Array<{ valor: 'federal' | 'estadual' | 'municipal'; label: string }> = [
  { valor: 'federal', label: 'Federal' },
  { valor: 'estadual', label: 'Estadual' },
  { valor: 'municipal', label: 'Municipal' },
];
